import React, {Component, Suspense, lazy} from 'react';
import {Redirect, Route, Router, Switch} from "react-router-dom";
import "bootstrap/scss/bootstrap.scss";
import './App.css';
import "./assets/scss/style.scss";
import "./assets/scss/font.scss";
import "./assets/scss/spacing.scss";
import {history} from "./app/common/duck/history";
import Notfound from "./app/common/notFound";
import requireAuth from "./app/common/requireAuth";
import localStorageService from "./app/common/duck/localStorageService";
import {connect} from "react-redux";
import userActions from "./app/user/duck/userActions";
import http from "./app/common/duck/httpService";
import queryString from "query-string";
import {Spinner} from "react-bootstrap";
import {Helmet} from 'react-helmet';

const Login = lazy(() => import("./app/user/login").then(m => ({default: m.Login})));
const Logout = lazy(() => import("./app/user/logout"));
const Farm = lazy(() => import("./app/farm/farm"));
const Dashboard = lazy(() => import("./app/dashboard/dashboard").then(m => ({default: m.Dashboard})));
const SignUp = lazy(() => import("./app/user/signUp"));
const BusinessInformation = lazy(() => import("./app/user/groupInvite/businessInformation").then(m => ({default: m.BusinessInformation})));
const PersonalInformation = lazy(() => import("./app/user/groupInvite/personalInformation").then(m => ({default: m.PersonalInformation})));
const InviteMembers = lazy(() => import("./app/user/groupInvite/inviteMembers").then(m => ({default: m.InviteMembers})));
const JoinGroup = lazy(() => import("./app/user/userInvite/joinGroup").then(m => ({default: m.JoinGroup})));

class App extends Component {

    componentDidMount() {
        if (this.isSignUpFlow()) {
            localStorageService.removeItems();
        }
        if (this.shouldLoadProfile() && !this.props.hasProfileDetails) {
            http.setToken(localStorageService.getToken());
            this.props.getProfile(localStorageService.getUserId());
            this.props.getPreferences();
            this.props.getParentRole();
        }

    }

    componentDidUpdate(){
        if(this.props.parentDetailsLoadingStatus === null){
          this.props.getParentRole();
        }
    }
    
    AuthedDashboard = requireAuth(Dashboard)
    AuthedFarm = requireAuth(Farm)

    render() {
        const isWaitingLogin = (
            !this.props.unAuthorized &&
            this.shouldLoadProfile() &&
            (!this.props.hasProfileDetails || !this.props.hasPreferences)
        );
        
        if (isWaitingLogin) {
            return (<React.Fragment>
                <div className="spinnerCentre"><Spinner animation="grow" size="lg" /></div>
            </React.Fragment>);
        }
        if (this.props.hasProfileDetails) {
            window.heap.identify(this.props.userName);
        }

        return (
            <React.Fragment>
                <Helmet>
                    <title>Groguru</title>
                </Helmet>
                <main>
                    <Router history={history}>
                        <Suspense fallback={<div className="spinnerCentre"><Spinner animation="grow" size="lg"/></div>}>
                            <Switch>
                                <Route path="/login" component={Login}/>
                                <Route path="/logout" component={Logout}/>
                                <Route path="/signUp/org/businessInfo" component={BusinessInformation}/>
                                <Route path="/signUp/org/personalInfo" component={PersonalInformation}/>
                                <Route path="/signUp/org/inviteMembers" component={InviteMembers}/>
                                <Route path="/signUp/member/personalInfo" component={JoinGroup}/>
                                <Route path="/signUp/:encryptedKey" component={SignUp}/>
                                <Route path="/dashboard" component={this.AuthedDashboard}/>
                                <Route path="/farm/:farmid" component={this.AuthedFarm}/>
                                <Route path="/not-found" component={Notfound}/>
                                <Redirect exact from="/" to="/dashboard"/>
                                <Redirect to="/not-found"/>
                            </Switch>
                        </Suspense>
                    </Router>
                </main>
            </React.Fragment>
        );
    }

    shouldLoadProfile() {
        return localStorageService.isTokenAvailable() && localStorageService.isUserIdAvailable() && !this.isSignUpFlow();
    }

    isSignUpFlow() {
        const isSignUpLink = history.location.pathname.startsWith('/signUp');
        const {invitationId} = queryString.parse(history.location.search);
        if(invitationId) return isSignUpLink;
    }
}

const mapStateToProps = (state) => ({
    userName: state.userDetails.profileDetails?.profile?.username,
    hasProfileDetails: !!state.userDetails.profileDetails?.profile,
    hasPreferences: !!state.userDetails.userPreferences?.preferences,
    unAuthorized: state.userDetails.profileDetails.unAuthorized,
    parentDetailsLoadingStatus: state.userDetails?.userPrivilages?.loadingStatus
});

const mapDispatchToProps = {
    getProfile: userActions.getProfile,
    getPreferences: userActions.getPreferences,
    getParentRole: userActions.getParentRole
};

const connectedApp = connect(mapStateToProps, mapDispatchToProps)(App);

export {connectedApp as App};



